import userHasPermission from '@webapp-next/lib/user-has-permission';
import {
  LIST_COLUMNS,
  LIST_COLUMNS_PERMISSIONS,
  getColumnKeyByValue,
  ListColumnsNames,
} from '@/modules/people/definitions/people-list';

export default function checkListColumnPermissionsByColumnIndex(
  column: ListColumnsNames
): boolean {
  if (!column) {
    return false;
  }

  if (column === LIST_COLUMNS.LEAVE_BALANCE) {
    return userHasPermission('Can_Approve_Leave_Pay_Lines');
  }

  const permissions =
    LIST_COLUMNS_PERMISSIONS[getColumnKeyByValue(column)] || [];

  for (const permission of permissions) {
    if (!userHasPermission(permission)) {
      return false;
    }
  }

  return true;
}
